import React from "react";

import { ReactComponent as RefreshIcon } from "assets/svgs/refresh.svg";
import { ReactComponent as CheckIcon } from "assets/svgs/success-check.svg";

import * as S from "./SectionObjective.style";

const cardsList = [
  {
    id: 1,
    icon: CheckIcon,
    description: (
      <>
        <strong>Meta 1 -</strong> 100% de Transparência das interações com a
        Administração Pública.
      </>
    ),
  },
  {
    id: 2,
    icon: RefreshIcon,
    description: (
      <>
        <strong>Meta 2 -</strong> Remuneração 100% íntegra da Alta
        administração.
      </>
    ),
  },
  {
    id: 3,
    icon: RefreshIcon,
    description: (
      <>
        <strong>Meta 3 -</strong> 100% da Cadeia de valor de alto risco treinada
        em Integridade.
      </>
    ),
  },
  {
    id: 4,
    icon: CheckIcon,
    description: (
      <>
        <strong>Meta 4 -</strong> 100% de Transparência da estrutura de
        Compliance e Governança.
      </>
    ),
  },
  {
    id: 5,
    icon: RefreshIcon,
    description: (
      <>
        <strong>Meta 5 -</strong> 100% de Transparência sobre Canais de
        Denúncias.
      </>
    ),
  },
];

const SectionObjective = () => {
  return (
    <S.SectionObjectiveContainer>
      <S.SectionObjectiveContent className="container">
        <S.SectionObjectiveHeader>
          <S.SectionObjectiveTitle>
            Metas do Movimento Transparência 100%
          </S.SectionObjectiveTitle>

          <S.SectionObjectiveDescription>
            Em 2025, aderimos ao Movimento Transparência 100%, iniciativa ligada
            à Rede Brasil do Pacto Global da Organização das Nações Unidas
            (ONU). O objetivo é demonstrar nosso compromisso com ações coletivas
            que promovam ética, integridade e transparência, além de nossas
            obrigações legais. O Movimento propõe 5 metas que as empresas devem
            cumprir até 2030. No primeiro ano, evoluímos nas metas 1 e 4.
          </S.SectionObjectiveDescription>
        </S.SectionObjectiveHeader>

        <S.SectionObjectiveList>
          <div>
            {cardsList.slice(0, 3).map((cardItem) => (
              <S.SectionObjectiveCard key={cardItem.id}>
                <span>
                  <cardItem.icon />
                </span>
                <S.SectionObjectiveCardDescription>
                  {cardItem.description}
                </S.SectionObjectiveCardDescription>
              </S.SectionObjectiveCard>
            ))}
          </div>

          <div>
            {cardsList.slice(3, 5).map((cardItem) => (
              <S.SectionObjectiveCard key={cardItem.id}>
                <span>
                  <cardItem.icon />
                </span>
                <S.SectionObjectiveCardDescription>
                  {cardItem.description}
                </S.SectionObjectiveCardDescription>
              </S.SectionObjectiveCard>
            ))}
          </div>
        </S.SectionObjectiveList>
      </S.SectionObjectiveContent>
    </S.SectionObjectiveContainer>
  );
};

export default SectionObjective;
